import React, { Component } from "react";
import FrappButton from "../utilities/FrappButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FrappModal from "../utilities/FrappModal";
import ThreeDotLoader from "../utilities/ThreeDotLoader"
import { NoMoreData } from "../utilities/ThreeDotLoader"
import FormGroup from "react-bootstrap/lib/FormGroup";
import FormControl from "react-bootstrap/lib/FormControl";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import ApiActions from "../../actions/ApiActions";
import SupportChat from './SupportChat'
class SupportApps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMissionDetail: false,
      showApplication: false,
      showSupport: true,
      msg: "",
      chats: [],
      missionApplication: {},
      mission: {},
      activeFilter: "open",
      supportCaseId: "",
      skip: 0,
      totalCases: 0,
      supportCase: [],
      category: "",
      page: 0,
      prevY: 0,
      loading: true,
      queryType: 'open',
      isFilterTouched: false,
      noMoreData: false
    };
    this.supportChatRef = React.createRef()
  }

  componentDidMount() {
    this.setState({ resolvedStatus: false, noFilter: false });
    this.fetchData();
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0
    };

    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    //using intersection observer instead of the normal event listener for scroll because intersection
    //observer is better suited for react and also it fires the event only once whenever the condition is met
    this.observer.observe(this.loadingRef);

    ApiActions.getSupportCase({
      // _vortex: true,
      populate: "",
      resolved: false,
      count: true
    }).then(resp => {
      this.setState({ totalCases: resp });
    });
    ApiActions.getSupportCase({
      // _vortex: true,
      populate: "",
      resolved: true,
      count: true
    }).then(resp => {
      this.setState({ totalCasesClosed: resp });
    });
  }

  handleObserver(entities, observer) {
    const y = entities[0].boundingClientRect.y;
    //this.state.isFilterTouched is used to avoid unnecessary scrolling call
    //when user switches the category
    if (this.state.prevY > y && !this.state.isFilterTouched) {
      this.fetchData();
    }
    this.setState({ prevY: y });
  }

  fetchData = () => {
    this.fetchSupportCases();
  };

  //this function is used to check the query params to be passed for each of the category,
  //the query params to the api will be passed dynamically based on the category selected
  checkForParams = (skip) => {
    let queryParams = {
      // _vortex: true,
      populate: "",
      skip: skip,
      limit: 50,
      resolved: false,
      sort: { createdAt: -1 }
    }
    switch (this.state.queryType) {
      case 'resolved':
        queryParams.resolved = true
        return queryParams
        
      case 'all':
        delete queryParams.resolved
        return queryParams
        
      case 'mission':
        queryParams.category = this.state.queryType
        return queryParams
        
      case 'verification':
        queryParams.category = this.state.queryType
        return queryParams
        
      case 'account':
        queryParams.category = this.state.queryType
        return queryParams
        
      case 'others':
        queryParams.category = this.state.queryType
        return queryParams
        
      case 'wallet':
        queryParams.category = this.state.queryType
        return queryParams
        
      case 'internship':
        queryParams.category = this.state.queryType
        return queryParams
        
      case 'telecall':
        queryParams.category = this.state.queryType
        return queryParams
        
      case 'onboarding':
        queryParams.category = this.state.queryType
        return queryParams
        
      default:
        return queryParams
    }
  }

  //this function will be triggered whenever user changes the category
  fetchCasesBasedOnCategory = () => {
    this.setState({supportCase: [], loading: true})
    let getQueryParams = this.checkForParams(this.state.skip)
    var skip = this.state.skip;
    let supportCase = this.state.supportCase;
    return ApiActions.getSupportCase(
      getQueryParams
    )
      .then(resp => {
        var newCase = resp;
        skip = skip + 50;
        this.setState({ supportCase: newCase, skip, isFilterTouched: false});
        this.setState({ loading: false });
      })
  }

  fetchSupportCases = () => {
    this.setState({ loading: true });
    var skip = this.state.skip;
    const setState = this.setState.bind(this);
    let supportCase = this.state.supportCase;
    let totalCases = this.state.totalCases;
    let getQueryParams = this.checkForParams(skip)
    return ApiActions.getSupportCase(
      getQueryParams
    )
      .then(resp => {
        var newCase = supportCase.concat(resp);

        skip = skip + 50;

        if(resp.length <=0){
          this.setState({noMoreData: true})
        }
        this.setState({ supportCase: newCase, skip });
        this.setState({ loading: false });
      })
      .then(setState);
  };

  render() {
    let totalCases = this.state.totalCases;
    let totalCasesClosed = this.state.totalCasesClosed;
    
    // Additional css
    const loadingCSS = {
      height: "100px",
      margin: "30px"
    };

    // To change the loading indicator behavior
    const loadingTextCSS = { display: this.state.loading ? "block" : "none" };

    return (
      <div className="support">
        <div className="total-card">
          Total Open Cases: {totalCases}
          <div>Total Resolved Cases: {totalCasesClosed}</div>
          <div>Total cards fetched: {this.state.supportCase.length}</div>
        </div>

        <form onSubmit={e => e.preventDefault()}>
          <FormGroup className="filter-query">
            <ControlLabel>Choose Query type</ControlLabel>
            <FormControl
              onChange={e => {
                // this.renderFilter(e)
                this.changeInQuery(e)
              }
              }
              name="activeFilter"
              value={this.state.activeFilter}
              componentClass="select"
            >
              <option value="resolved">Resolved</option>
              <option value="open">Open</option>
              <option value="all">All</option>
              <option value="mission">Mission</option>
              <option value="verification">Verification</option>
              <option value="account">Account</option>
              <option value="others">Others</option>
              <option value="wallet">Wallet</option>
              <option value="internship">Internship</option>
              <option value="telecall">Telecall</option>
              <option value="onboarding">Onboarding</option>
            </FormControl>
          </FormGroup>
        </form>
        <ToastContainer draggable={true} />
        {this.renderMissionModal()}
        <div className="query-list-apps">
            {this.state.supportCase.length > 0 && this.state.supportCase.map((each, i) => {
                return this.renderSupportCard(each, i);
              })
            }
        </div>
        <div
          ref={loadingRef => (this.loadingRef = loadingRef)}
          style={loadingCSS}
        >
          {this.state.noMoreData && !this.state.loading ? <NoMoreData msg={'Reached the end of list.. no more data present'}/> : <span style={loadingTextCSS}><ThreeDotLoader/></span>}
        </div>
      </div>
    );
  }

  renderFilter = e => {
    this.setState({ activeFilter: e.target.value, queryType: e.target.value });
    if (e.target.value === "resolved")
      this.setState({ resolvedStatus: true, noFilter: false });
    else if (e.target.value === "open")
      this.setState({ resolvedStatus: false, noFilter: false });
    else if (e.target.value === "all") this.setState({ noFilter: true });
    else if (e.target.value === "wallet") this.setState({ resolvedStatus: "wallet", noFilter: false });
    else if (e.target.value === "account") this.setState({ resolvedStatus: "account", noFilter: false });
    else if (e.target.value === "verification") this.setState({ resolvedStatus: "verification", noFilter: false });
    else if (e.target.value === "mission") this.setState({ resolvedStatus: "mission", noFilter: false });
    else if (e.target.value === "others") this.setState({ resolvedStatus: "others", noFilter: false });
    else if (e.target.value === "internship") this.setState({ resolvedStatus: "internship", noFilter: false });
    else if (e.target.value === "telecall") this.setState({ resolvedStatus: "telecall", noFilter: false });
    else if (e.target.value === "onboarding") this.setState({ resolvedStatus: "onboarding", noFilter: false });
  };

  //set the queryType when user click on a different category
  changeInQuery = async (e) => {
    const category = e.target.value
    this.setState({ activeFilter: e.target.value, isFilterTouched: true})
    //fn fetchCasesBasedOnCategory is based as a callback along with setState so
    //that fn fetchCasesBasedOnCategory gets the latest updated value of states
    this.setState({queryType: category, skip: 0}, this.fetchCasesBasedOnCategory)
  }

  renderMissionModal = () => {
    let id = this.state.missionId;
    let authToken = localStorage.getItem("authToken");
    let supportCaseId = this.state.supportCaseId.id;
    let category = this.state.category;
    let urlSend;
    if (process.env.NODE_ENV === 'development') {
      urlSend = 'https://staging.futwork.com'
    }

    if (process.env.NODE_ENV === 'production') {
      urlSend = 'https://futwork.com'
    }



    let urlFinal;
    let propsToSupportChat = {}
    if (id) {
      urlFinal =
        `${urlSend}/support?mission=${id}&category=${category}&authToken=${authToken}&admin=true&supportCaseId=${supportCaseId}`
      // "http://localhost:2019/support?mission=5e71fc57c9d8be00107fba3e&authToken=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJiYXNlIjoiNWExYmY4YmFmOWM0YTdlM2FhZjc3N2FlIiwiaWF0IjoxNTg0NjIzMDkzLCJleHAiOjE1ODU4MzI2OTMsImF1dGgiOiJhZG1pbiJ9.Lqrsd9RwGAefrdPV8CxTJiwVUNTNwULO1iokn3QkiIzyXCoNr9wdcLEsUxWCXDiHPp2iNNJTaXJnmbfg2Picaw&admin=true&supportCaseId=5e73b22f905db100170e9fc1"

      propsToSupportChat={
         urlSend,
         id,
         category,
         admin: true,
         supportCaseId
      }
    }


    else {
      urlFinal =
        `${urlSend}/support?category=${category}&authToken=${authToken}&admin=true&supportCaseId=${supportCaseId}`
      // "http://localhost:2019/support?mission=5e71fc57c9d8be00107fba3e&authToken=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJiYXNlIjoiNWExYmY4YmFmOWM0YTdlM2FhZjc3N2FlIiwiaWF0IjoxNTg0NjIzMDkzLCJleHAiOjE1ODU4MzI2OTMsImF1dGgiOiJhZG1pbiJ9.Lqrsd9RwGAefrdPV8CxTJiwVUNTNwULO1iokn3QkiIzyXCoNr9wdcLEsUxWCXDiHPp2iNNJTaXJnmbfg2Picaw&admin=true&supportCaseId=5e73b22f905db100170e9fc1"

      propsToSupportChat={
        urlSend,
        id,
        category,
        admin: true,
        supportCaseId
     }
    }



    return (
      <FrappModal
        onCloseButton={true}
        className='modal-large-600'
        show={this.state.showMissionDetail}
        ref={c => (this.modal = c)}
        closeModal={() => this.modal.toggle(false)}
      >
        {this.showApplicationDetails()}
        <div className='chat-window-wrapper'>
        {/* className="wrapper" */}
          {this.state.showSupport ? 
          <SupportChat {...propsToSupportChat} ref={this.supportChatRef}/>
          : null}
          <FrappButton
              className="mission-btn"
              handler={() => {this.supportChatRef.current.childMethod()}}
            >
             Get latest chats
            </FrappButton>
        </div>
      </FrappModal>
    );
  };

  showApplicationDetails = () => {
    let mission = this.state.mission;
    let missionApplication = this.state.missionApplication;
    if (missionApplication) var { tasks } = missionApplication;

    if (this.state.showApplication)
      return (
        <div className="wrapper" id="mission">
          <div className="mission-details">
            <div className="heading">
              {" "}
              <div className="img">
                {" "}
                <img src={require("../../assets/images/control-mission.gif")} />
              </div>{" "}
              Mission Details
            </div>
            <div className="wrap-in">
              <div className="info">
                {" "}
                <p> Mission Id:</p>
                <p> {mission.id}</p>
              </div>
              <div className="info">
                {" "}
                <p> Mission Name:</p>
                <p>{mission.name}</p>
              </div>
            </div>
            <div className="heading">
              {" "}
              <div className="img">
                {" "}
                <img src={require("../../assets/images/control-task.gif")} />
              </div>{" "}
              Tasks Details
            </div>
            <div className="wrap-in" id="tasks">
              {tasks &&
                tasks.map((r, i) => (
                  <div className="info" id="task">
                    <h4>Task {i + 1}&nbsp;&nbsp;&nbsp;&nbsp;</h4>
                    <p>{r.id}</p>
                    <p> {r.status}</p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      );
    return null;
  };

  handleClick = queryData => {
    this.renderModal(queryData);
    var { missionApplication } = queryData;
    this.setState({
      category: queryData.category,
      showSupport: true,
      showApplication: false,
      msg: queryData.message
    })

    queryData.mission ? this.setState({
      mission: queryData.mission,
      missionId: queryData.mission.id
    }) :
      this.setState({
        mission: [],
        missionId: ""
      });

    this.setState({ missionApplication: missionApplication });











  };
  renderModal = supportCaseId => {
    this.modal.toggle(true);
    this.setState({ supportCaseId: supportCaseId });
  };
  renderSupportCard = (queryData, i) => {
    let supportCaseId = queryData && queryData.id;
    let missionId = queryData && queryData.mission && queryData.mission.id;
    let category = queryData.category;
    if (queryData)
      return (
        <div
          key={i}
          className="query-card-apps"
          onClick={() => this.handleClick(queryData)}
        >
          <div className="category-support">
            {
              queryData.category ? queryData.category : null
            }
          </div>
          {this.renderBackQuote()}
          <div className="resolve">
            <h5> Resolved</h5>
            <label class="switch" onClick={e => e.stopPropagation()}>
              <input
                type="checkbox"
                onChange={() => this.handleResolve(i, queryData, supportCaseId)}
                checked={queryData.resolved}
              />
              <span className="slider round" />
            </label>
          </div>
          {queryData.lastMessage ? (
            <div
              className="message"
              dangerouslySetInnerHTML={{ __html: queryData.lastMessage }}
            />
          ) : (
              ""
            )}


          <hr />
          <div className="name">
            <span>{queryData && queryData.user && queryData.user.firstname && queryData.user.firstname.toLowerCase()} {queryData && queryData.user && queryData.user.certifiedCaller ? <span className="certified">(Certified)</span> : null } </span>
          </div>
          <div className="contact">
            <div className="phone">
              <img src={require("../../assets/images/phone.svg")} alt="" />
              <span>{queryData && queryData.user && queryData.user.mobile}</span>
            </div>
            <div className="email">
              <img src={require("../../assets/images/email.svg")} alt="" />
              <span>{queryData && queryData.user && queryData.user.email}</span>
            </div>
            <div className="reply-btn">
              <FrappButton
                handler={e => 
                  this.handleClick(queryData)
                  // this.redirectWindow(e, missionId, category, supportCaseId)
                }
              >
                <h5>Reply Now</h5>
              </FrappButton>
            </div>
          </div>
        </div>
      );
  };
  handleResolve = (i, queryData, supportCaseId) => {
    ApiActions.setResolve(supportCaseId).then(resp => {
      toast("Done");
    });
    let temp = queryData;

    temp.resolved = !temp.resolved;

    this.setState({ queryData: temp });
    //shoulg go in .then
    //ApiAction.putRequest(something).then()
  };
  redirectWindow = (e, id, category, supportCaseId) => {
    this.setState({ supportCaseId: supportCaseId });
    this.setState({ category: category })
    e.stopPropagation();
    let authToken = localStorage.getItem("authTokenVortex");
    let url;
    if (process.env.NODE_ENV === 'development') {
      url = 'https://staging.futwork.com'
    }

    if (process.env.NODE_ENV === 'production') {
      url = 'https://futwork.com'
    }
    if (id) {
      let newWnd = window.open(
        `${url}/support?mission=${id}&category=${category}&authToken=${authToken}&admin=true&supportCaseId=${supportCaseId}`
        // "http://localhost:2019/support?mission=5e71fc57c9d8be00107fba3e&authToken=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJiYXNlIjoiNWExYmY4YmFmOWM0YTdlM2FhZjc3N2FlIiwiaWF0IjoxNTg0NjIzMDkzLCJleHAiOjE1ODU4MzI2OTMsImF1dGgiOiJhZG1pbiJ9.Lqrsd9RwGAefrdPV8CxTJiwVUNTNwULO1iokn3QkiIzyXCoNr9wdcLEsUxWCXDiHPp2iNNJTaXJnmbfg2Picaw&admin=true&supportCaseId=5e73b22f905db100170e9fc1"
      );
      newWnd.opener = null
    } else {
      let newWnd = window.open(
        `${url}/support?category=${category}&authToken=${authToken}&admin=true&supportCaseId=${supportCaseId}`
        // "http://localhost:2019/support?mission=5e71fc57c9d8be00107fba3e&authToken=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJiYXNlIjoiNWExYmY4YmFmOWM0YTdlM2FhZjc3N2FlIiwiaWF0IjoxNTg0NjIzMDkzLCJleHAiOjE1ODU4MzI2OTMsImF1dGgiOiJhZG1pbiJ9.Lqrsd9RwGAefrdPV8CxTJiwVUNTNwULO1iokn3QkiIzyXCoNr9wdcLEsUxWCXDiHPp2iNNJTaXJnmbfg2Picaw&admin=true&supportCaseId=5e73b22f905db100170e9fc1"
      );
      newWnd.opener = null
    }

  };
  renderBackQuote = () => {
    return (
      <img
        alt=""
        className="quote"
        src="data:image/svg+xml;base64,
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"
      />
    );
  };
}

export default SupportApps;
